import { HTTP } from '../config/http-axios.js';

const HTTP_GET = 'GET';
const HTTP_POST = 'POST';
const HTTP_PUT = 'PUT';
const HTTP_PATCH = 'PATCH';
const HTTP_DELETE = 'DELETE';

class ApiBaseService {

    static request(endpoint, method, payload, headers = {}) {
        if (headers['Content-Type'] === undefined) {
            headers['Content-Type'] = 'application/json';
        }

        const http = HTTP;

        return new Promise((resolve, reject) => {
            let response;
            switch (method) {
                case HTTP_GET:
                    response = http.get(endpoint, { headers });
                    break;
                case HTTP_POST:
                    response = http.post(endpoint, payload, { headers });
                    break;
                case HTTP_PUT:
                    response = http.put(endpoint, payload, { headers });
                    break;
                case HTTP_PATCH:
                    response = http.patch(endpoint, payload, { headers });
                    break;
                case HTTP_DELETE:
                    response = http.delete(endpoint, { headers });
                    break;
                default:
                    console.error('Wrong HTTP method requested');
            }
            response
                .then((res) => { resolve(res); })
                .catch((err) => { reject(err.response); });
        });
    }
}

export default ApiBaseService;